import { WarningTwoIcon } from "@chakra-ui/icons";
import { Heading, VStack } from "@chakra-ui/layout";

import BaseLayout from "../templates/BaseLayout";

export default function NotFound() {
    return (
        <BaseLayout isHome={false}>
            <VStack mt="10">
                <WarningTwoIcon boxSize="10" color="red.400" />
                <Heading>404 Not Found</Heading>
            </VStack>
        </BaseLayout>
    );
}
